import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import ContactPage from '../../pages/contact-page/ContactPage';
import PayPage from '../../pages/pay-page/PayPage';
import routerLinks from './routerLinks';
import HomePage from '../../pages/home-page/HomePage';
import OtpVerification from '../otp-validation/OtpVerification';
import ErrorPage from '../ErrorPage/ErrorPage';

const Routes = () => {
  return (
    // <Route
    //   render={({ location }) => {
    //     return (
    //       <PageTransition preset="moveToLeftFromRight" transitionKey={location.pathname}>
    <Switch>
      <Route exact path={routerLinks.homePage}>
        {<Redirect to="/register" />}
      </Route>
      <Route exact path={routerLinks.contactPage}>
        <ContactPage />
      </Route>
      {/* <Route exact path={routerLinks.OtpVerification}>
        <OtpVerification />
      </Route> */}
      <Route exact path={routerLinks.payPage}>
        <PayPage />
      </Route>
      <Route exact path={'*'}>
        <ErrorPage />
      </Route>
    </Switch>
    //       </PageTransition>
    //     );
    //   }}
    // />
  );
};

export default Routes;
